export const API_CCM_MESSAGES = 'core/ccm/messages';
export const API_MESSAGES_VOCABULARY = 'core/vocabulary/message';
